import { PAGER_PHASE_ORDER } from '../utils/phases';

interface PhaseStepperProps {
    /** null = pre-estimation, all segments gray */
    currentIndex: number | null;
}

const PhaseStepper = ({ currentIndex }: PhaseStepperProps) => {
    return (
        <div className="flex items-start gap-1.5">
            {PAGER_PHASE_ORDER.map((phase, i) => {
                const isPast = currentIndex !== null && i < currentIndex;
                const isActive = currentIndex !== null && i === currentIndex;
                const fillPct = currentIndex !== null && i <= currentIndex ? 100 : 0;
                const labelClass = isActive
                    ? 'text-[11px] font-semibold text-blue-700 text-center'
                    : isPast
                        ? 'text-[11px] text-gray-500 text-center'
                        : 'text-[11px] text-gray-400 text-center';
                return (
                    <div key={phase} className="flex-1 flex flex-col items-stretch gap-2 min-w-0">
                        <div className="h-1.5 bg-gray-200 relative">
                            {fillPct > 0 && (
                                <div
                                    className="absolute inset-y-0 left-0 bg-blue-600"
                                    style={{ width: `${fillPct}%` }}
                                />
                            )}
                        </div>
                        <span className={`${labelClass} truncate`} title={phase}>
                            {phase}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default PhaseStepper;
